import * as marietta from '../../../..';
import { Dialog } from '../../../../core/view';
import { ThreeView } from '../../../../view3d/webcad';

export class WizardStartDialog extends Dialog {

  /**
   * HTML生成
   */
  buildContent() {
    let id: string | null;
    let title: string | null;
    let contents: string | null;
    let footer: string | null;

    // ダイアログのコンテンツ生成
    id = 'WizardStartDialog';

    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        title = '部屋指定ウィザード';
        break;
      default:
        title = 'RoomType Select Wizard';
        break;
    }

    // ピンの有無を確認
    const hasPin = ThreeView.get().wizardManager.getTargetPin().length > 0;

    contents = '<div class="WizardStartDialogBody">';
    contents += '<div class="explanationBody">部屋ウィザードを開始しますか？</div>';
    // ピンがある場合のみスキップ案内を表示
    if (hasPin) {
      contents += '<p>※ピン編集ウィザードを開始する場合は、スキップを押してください。</p>';
    }
    contents += '</div>';

    // footer = '<button id="btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    footer = '';
    // ピンがある場合のみスキップボタンを表示
    if (hasPin) {
      footer += '<button id="btnSkip"><span class="jp">スキップ</span><span class="en">Skip</span></button>';
    }
    footer += '<button id="btnStart"><span class="jp">開始する</span><span class="en">Start</span></button>';

    this.createDialog(id, title, contents, footer);

    document.querySelector('#WizardStartDialog #btnStart')
      ?.addEventListener('click', this.onStartButtonClicked);
    // document.querySelector('#WizardStartDialog #btnCancel')?.addEventListener('click', this.close);
    // ピンがある場合のみスキップボタンのイベントリスナーを設定
    if (hasPin) {
      document.querySelector('#WizardStartDialog #btnSkip')
        ?.addEventListener('click', this.skip);
    }
  }

  /**
   * OKボタンがクリックされた
   */
  onStartButtonClicked = () => {
    this.closeEvent();

    // 次のwizardに進む
    if (ThreeView.get()
      .wizardManager
      .getTargetRoom().length === 0) {
      ThreeView.get()
        .wizardManager
        .next(2);
    } else {
      ThreeView.get()
        .wizardManager
        .next(1);
    }
  };

  close = () => {
    this.closeEvent();

    // wizardの終了
    ThreeView.get()
      .wizardManager
      .end();
  };

  closeEvent() {
    super.closeEvent();
  }

  private skip = () => {
    // 次のwizardに進む
    ThreeView.get()
      .wizardManager
      .next(2);
  };
}
